import { axiosInstance } from "./axiosInstance";

export const categoryProductService = {
    getCategoryProduct: async ( filters ) => {
        return await axiosInstance.get('/api/superadmin/product-category', { params: filters })
    },
    createCategoryProduct: async (data) => {
        return await axiosInstance.post('/api/superadmin/product-category/create', data)
    },
    updateCategoryProduct: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/product-category/update/${id}`, data)
    },
    deleteCategoryProduct: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/product-category/delete/${id}`)
    },
}